import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContentResultType } from '../../shared/interfaces/content-result.interface';
import { API_ENDPOINTS } from '../../shared/constants/api-endpoints';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppConfiguration {
  public constructor(private readonly http: HttpClient) {}

  public getAppConfiguration(keyName: string): Observable<ContentResultType> {
    const url = `${location.origin}/${API_ENDPOINTS.appConfiguration}/keys/${keyName}`;
    return this.http.get<ContentResultType>(url);
  }
}
